const React = require('react');
const UIBLogo = require('../UIBLogo');

const LinkLogo = ({ url }) => (
	<a href={url} className="uibLogo">
    	{UIBLogo}
    </a>
);

module.exports = LinkLogo;